import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function PricingPage() {
  const { t } = useTranslation();
  const { subscription, user } = useAuthStore();

  const plans = [
    {
      key: 'trial',
      name: t('plans.trial'),
      nameAr: 'تجريبي',
      price: 'Free',
      duration: t('plans.durations.trial10Days'),
      features: [t('plans.features.fullAccess'), t('plans.features.analytics'), '10 days'],
      cta: user ? t('plans.currentPlan') : t('auth.register'),
      popular: false,
    },
    {
      key: 'basic',
      name: t('plans.basic'),
      nameAr: 'أساسي',
      price: 'Free',
      duration: 'After trial',
      features: [t('plans.features.limitedAccess'), '-', '-'],
      cta: t('plans.currentPlan'),
      popular: false,
    },
    {
      key: 'pro',
      name: t('plans.pro'),
      nameAr: 'احترافي',
      price: '$19.99',
      duration: t('plans.durations.monthly'),
      features: [t('plans.features.fullAccess'), t('plans.features.analytics'), '-'],
      cta: t('plans.upgrade'),
      popular: true,
    },
    {
      key: 'enterprise',
      name: t('plans.enterprise'),
      nameAr: 'مؤسسي',
      price: '$199.99',
      duration: t('plans.durations.yearly'),
      features: [t('plans.features.fullAccess'), t('plans.features.analytics'), t('plans.features.prioritySupport')],
      cta: t('plans.upgrade'),
      popular: false,
    },
  ];

  const currentPlanName = subscription?.plan?.name || 'Basic';

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold mb-2">{t('nav.pricing')}</h1>
        <p className="text-muted-foreground">Choose the plan that fits your preparation needs</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((plan) => {
          const isCurrent = currentPlanName === plan.name;
          return (
            <div
              key={plan.key}
              className={`relative p-6 border rounded-lg bg-card flex flex-col ${
                plan.popular ? 'border-primary ring-1 ring-primary' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
                  Popular
                </div>
              )}

              <h3 className="text-lg font-semibold">{plan.name}</h3>
              <div className="text-3xl font-bold mt-2">{plan.price}</div>
              <div className="text-sm text-muted-foreground mb-4">{plan.duration}</div>

              <ul className="space-y-2 mb-6 flex-1 text-sm">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-center gap-2">
                    <span className="text-green-500">{f === '-' ? <span className="text-muted-foreground">-</span> : '✓'}</span>
                    <span className={f === '-' ? 'text-muted-foreground' : ''}>{f}</span>
                  </li>
                ))}
              </ul>

              {isCurrent ? (
                <div className="w-full text-center px-4 py-2 bg-muted rounded-lg font-medium text-muted-foreground">
                  {t('plans.currentPlan')}
                </div>
              ) : (
                <Link
                  to={user ? '/payment' : '/login'}
                  className={`w-full text-center px-4 py-2 rounded-lg font-medium transition-colors ${
                    plan.popular
                      ? 'bg-primary text-primary-foreground hover:opacity-90'
                      : 'border hover:bg-accent'
                  }`}
                >
                  {plan.cta}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
